export class Like {
  constructor(
    public likes: number,
    public likedByUser: boolean,
    public id?: string
  ) {}
}
